import React from 'react'
import { OfferCardSection } from '../../../transports/home-page-transport'
import { CardsContainer } from './styles'
import OfferCard from './offer-card'
import { useTranslation } from '../../../hooks/locale'
import { Section, TitleContainer, Title } from '../common/styles'

interface OfferCardsSectionProps {
    offerCardSection: OfferCardSection
}

const OfferCardsSection: React.FC<OfferCardsSectionProps> = ({ offerCardSection }) => {
    const { t } = useTranslation()
    const { heading, cards } = offerCardSection

    return (
        <Section>
            {!!heading && (
                <TitleContainer>
                    <Title>{heading}</Title>
                </TitleContainer>
            )}
            <CardsContainer>
                {!!cards &&
                    cards.length > 0 &&
                    cards.map((card, index) => (
                        <OfferCard
                            key={`${card.heading}-${index}`}
                            heading={card.heading}
                            description={card.description}
                            imageUrl={card.image?.formats?.medium?.url || card.image?.url}
                            url={card.url}
                            buttonText={t('checkNow')}
                        />
                    ))}
            </CardsContainer>
        </Section>
    )
}

export default OfferCardsSection
